import { render, staticRenderFns } from "./AffectedForm.vue?vue&type=template&id=3a38319b&scoped=true"
import script from "./AffectedForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AffectedForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AffectedForm.vue?vue&type=style&index=0&id=3a38319b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a38319b",
  null
  
)

export default component.exports